import React from 'react';

export enum Gender {
  Male = 'male',
  Female = 'female',
  NonBinary = 'nonbinary'
}

export enum AppStep {
  Landing = 'LANDING',
  Auth = 'AUTH',
  Onboarding = 'ONBOARDING',
  Home = 'HOME',
  Scenario = 'SCENARIO',
  Chat = 'CHAT',
  Paywall = 'PAYWALL',
  Profile = 'PROFILE',
  BlogList = 'BLOG_LIST',
  BlogPost = 'BLOG_POST',
  Privacy = 'PRIVACY',
  Terms = 'TERMS',
  Contact = 'CONTACT',
  Support = 'SUPPORT',
  TalkToTaskPrivacy = 'TALKTOTASK_PRIVACY',
  TalkToTaskTerms = 'TALKTOTASK_TERMS',
  TalkToTaskSupport = 'TALKTOTASK_SUPPORT'
}

export interface UserProfile {
  gender: Gender;
  targetGender: Gender;
  name: string;
  photoURL?: string;
  // Subscription fields
  subscriptionExpiryDate?: number; // Timestamp
  planType?: 'trial' | 'monthly' | 'yearly';
  isGuest?: boolean; // New field for Guest Mode
}

export interface ScenarioConfig {
  context: string;
  difficulty: 'Easy' | 'Medium' | 'Hard';
  relationshipStatus: 'Strangers' | 'Dating' | 'Long Distance' | 'Complicated';
}

export interface ChatMessage {
  id: string;
  sender: 'user' | 'ai';
  text: string;
  timestamp: number;
  // AI specific fields
  coachingTip?: string;
  score?: number; // 1-10
}

export interface SavedChat {
  id: string;
  scenario: ScenarioConfig;
  messages: ChatMessage[];
  lastUpdated: number;
  averageScore: number;
}

export interface GeminiResponseSchema {
  personaResponse: string;
  coachingTip: string;
  score: number;
}

export interface BlogPost {
  id: string;
  title: string;
  excerpt: string;
  content: React.ReactNode; // Can be simple strings or JSX
  date: string;
  readTime: string;
  category: string;
  imageUrl: string;
}